module.exports = __webpack_public_path__ + "img/sixtyfour.59248ee0.png";